import { tss } from 'tss-react';

export const useStyles = tss.create(({ theme }) => ({
  root: {
    width: '100%',
    minWidth: 570,
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    '&:focus': {
      border: 'solid 5px red',
      boxSizing: 'border-box'
    }
  },
  buttons: {
    padding: '5px 7px 3px 7px',
    display: 'flex',
    justifyContent: 'space-between',
    background: 'var(--accent-light-color)',
    alignItems: 'center'
  },
  buttonLeft: {
    flex: '1'
  },
  buttonRight: {
    flex: '1',
    textAlign: 'right'
  },
  center: {
    textAlign: 'center',
    flex: '3'
  },
  contentContainer: {
    height: '100%',
    // The height SHOULD be here. If removed, the scroll will stop working;
    maxHeight: 'calc( 90vh - 125px )', // 80px is the height of the input container (without pills) + 45px is the height of the header
    overflowY: 'auto'
  },
  navigationTitle: {
    fontSize: '14px',
    fontWeight: '500',
    paddingLeft: '12px'
  }
}));
